var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Loader',{attrs:{"value":_vm.promises.fetch}},[_c('div',{staticClass:"flatfinder-embed-page"},[(_vm.$path('flatfinders.length', _vm.item))?_c('Flatfinder',{attrs:{"value":_vm.item.flatfinders,"properties":_vm.$path('metadata.siteSettings.featuredResidentialProperties', _vm.item),"prevent-navigation":true}}):_vm._e()],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }